import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.timekeeping')
  .factory('AttendanceAPI', AttendanceAPI);

function AttendanceAPI(): BringozApi {
  return {
    base: `/attendance`,
    infiniteScroll: {
      address: `/attendance`,
      cmd: 'GET'
    },
    actions: {
      getResources: {
        address: '{agentId}/resources',
        cmd: 'GET',
        updateable: false
      },
      clockIn: {
        address: '{agentId}/clockIn',
        cmd: 'POST',
        updateable: false
      },
      clockOut: {
        address: '{agentId}/clockOut',
        cmd: 'POST',
        updateable: false
      },
      startBreak: {
        address: '{agentId}/break',
        cmd: 'POST',
        updateable: false
      }
    }
  }
}
